var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"article-wrapper",attrs:{"id":"article"}},[_c('v-card',{staticClass:"pa-6 pa-md-12",attrs:{"color":_vm.color,"flat":"","min-height":"80vh"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }